export function setFee(fee) {
    return {type: "SET_FEE", fee}
}

export function clearFees() {
    return {type: "CLEAR_FEES"}
}
